export default "__VITE_ASSET__CNfy3ser__"